import * as React from "react";
export const provideContext = contexts => Component => {
    const reduced = contexts.reduce((PreviousComponent, current) => {
        return () => (React.createElement(current.context.Provider, { value: current.value },
            React.createElement(PreviousComponent, null)));
    }, Component);
    return reduced;
};
//# sourceMappingURL=provideContext.js.map